import { LEXILE_TOGGLE_STATE } from '../actionTypes/reading/apiActionTypes';

export const initialState = {
    isLexileShown: false,
};

export const reducer = (state = initialState, action = {}) => {
    if (action.type === LEXILE_TOGGLE_STATE.SET) {
        return {
            ...state,
            isLexileShown: action.isLexileShown,
        };
    }
    if (action.type === LEXILE_TOGGLE_STATE.CLEAR) {
        return initialState;
    }
    return state;
};

const isLexileShown = state => state.isLexileShown;

export const selectors = {
    isLexileShown,
};
